import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1530956d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "dashboard-container" }
const _hoisted_3 = { class: "row g-4 mb-4" }
const _hoisted_4 = { class: "stat-label" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6 mb-4" }
const _hoisted_8 = { class: "chart-title" }
const _hoisted_9 = { class: "col-lg-6 mb-4" }
const _hoisted_10 = { class: "chart-title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" Stats Row "),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.stats, (stat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stat.id,
              class: "col-lg col-md-4 col-sm-6"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["stat-card", { 'form-loading': $data.loading }]),
                style: _normalizeStyle({ '--card-color': stat.color })
              }, [
                _createElementVNode("div", {
                  class: "stat-icon",
                  style: _normalizeStyle({ background: stat.gradient })
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(stat.icon)
                  }, null, 2 /* CLASS */)
                ], 4 /* STYLE */),
                _createElementVNode("div", _hoisted_4, _toDisplayString(stat.label), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, _toDisplayString(stat.value), 1 /* TEXT */),
                _createElementVNode("div", {
                  class: _normalizeClass(['stat-trend', stat.trendDirection])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`fas fa-arrow-${stat.trendDirection === 'up' ? 'up' : 'down'}`)
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(stat.trend), 1 /* TEXT */)
                ], 2 /* CLASS */)
              ], 6 /* CLASS, STYLE */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createCommentVNode(" Charts Row "),
        _createElementVNode("div", _hoisted_6, [
          _createCommentVNode(" Signups Chart "),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["chart-card", { 'form-loading': $data.loading }])
            }, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString($setup.lms_website.__('Signups in {0}', [$data.current_year])), 1 /* TEXT */),
              (!$data.loading)
                ? (_openBlock(), _createBlock(_component_VueApexCharts, {
                    key: 0,
                    height: "250",
                    options: $data.signupsChartOptions,
                    series: $data.signupsChartSeries
                  }, null, 8 /* PROPS */, ["options", "series"]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]),
          _createCommentVNode(" Enrollments Chart "),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(["chart-card", { 'form-loading': $data.loading }])
            }, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString($setup.lms_website.__('Enrollments in {0}', [$data.current_year])), 1 /* TEXT */),
              (!$data.loading)
                ? (_openBlock(), _createBlock(_component_VueApexCharts, {
                    key: 0,
                    height: "250",
                    options: $data.enrollmentsChartOptions,
                    series: $data.enrollmentsChartSeries
                  }, null, 8 /* PROPS */, ["options", "series"]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ])
        ])
      ])
    ])
  ]))
}